import Axios from "axios";
import _ from "lodash";
import { parseCookies } from "nookies";
import TokenError from "../helpers/util/FSMError";
import AbstractAPIInterface from "./abstract-api-interface";
const cookies = parseCookies();

export default class AxiosAPIInterface extends AbstractAPIInterface {
	constructor({ resoucePath, baseUrl }) {
		super();
		this._resouceName = resoucePath || "";
		this._baseUrl = baseUrl || process.env.FSM_REST_ENDPOINT;
		this._accessToken = cookies["token"] || "";
		this._header = {
			access_token: `bearer ${this._accessToken}`
		};
		this._axios = Axios.create({
			baseURL: this._baseUrl + this._resouceName,
			headers: this._header
		});
		this._axios.CancelToken = Axios.CancelToken;
		this._axios.isCancel = Axios.isCancel;
	}
	get({ path = "", params = {}, headers = {} }) {
		return this._axios
			.get(path, { headers, params })
			.then(response => response.data.data);
	}
	post({
		path = "",
		body = {},
		params = {},
		headers = {},
		isDetailedResponse = false
	}) {
		return this._axios.post(path, body, { headers, params }).then(response => {
			if (isDetailedResponse) {
				return response;
			}
			return response.data.data;
		});
	}
	put({ path = "", body = {}, params = {}, config = {} }) {
		return this._axios
			.put(path, body, { params, ...config })
			.then(response => {
				if (!_.isEmpty(config)) return response;
				return response.data.data;
			})
			.catch(err => {
				if (!_.isEmpty(config)) {
					if (this._axios.isCancel(err)) {
						throw new TokenError(err);
					}
				}
				throw err;
			});
	}
	patch({ path = "", body = {}, params = {} }) {
		return this._axios
			.patch(path, body, { params })
			.then(response => response.data.data);
	}
	delete({ path = "", params = {}, config = {} }) {
		return this._axios
			.delete(path, { params, ...config })
			.then(response => response.data.data);
	}
}
